import React from "react";
import { Link } from "react-router-dom";
import styles from "../../styles/landing.module.css";

const Footer = () => {
  return (
    <footer className={styles.landingFooter}>
      <div className={styles.footerContent}>
        <div className={styles.footerLogo}>
          <h3>Memory Curve</h3>
          <p>Optimize your learning</p>
        </div>
        <div className={styles.footerLinks}>
          <div className={styles.footerColumn}>
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#scientific-back">Scientific Background</a></li>
              <li><a href="#faq">FAQ</a></li>
            </ul>
          </div>
          <div className={styles.footerColumn}>
            <h4>Account</h4>
            <ul>
              <li><Link to="/login">Log in</Link></li>
              <li><Link to="/register">Sign up</Link></li>
            </ul>
          </div>
          <div className={styles.footerColumn}>
            <h4>Memory Curve</h4>
            <ul>
              <li><Link to="/terms">Terms and Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
            </ul>
          </div>
          <div className={styles.footerColumn}>
            <h4>App Creator</h4>
            <ul>
              <li><a href="https://github.com/KhanSimon" target="_blank" rel="noopener noreferrer">Simon Khan</a></li>
            </ul>
          </div>
          <div className={styles.footerColumn}>
            <h4>Contact Us</h4>
            <ul>
              <li><a href="mailto:support@memorycurve.fr">Email</a></li>
              <li><a href="mailto:support@memorycurve.fr">Support</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className={styles.footerBottom}>
        <p>&copy; {new Date().getFullYear()} Memory Curve. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 